module.exports = __webpack_public_path__ + "static/media/AvenirNext-Medium.f5ac3f0c.woff";